import { Link } from 'react-router-dom';
import type { ContentItem } from '@/types/content';
import { formatViews } from '@/lib/format';

interface HotRankingProps {
  items: ContentItem[];
}

export default function HotRanking({ items }: HotRankingProps) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
      {items.map((item, index) => (
        <Link
          key={item.id}
          to={`/detail/${item.id}`}
          className="flex items-center gap-3 md:gap-4 px-3 md:px-4 py-3 border-b border-background-100 last:border-b-0 hover:bg-background-100 transition-colors cursor-pointer"
        >
          <span
            className={`w-7 h-7 shrink-0 rounded-md flex items-center justify-center font-heading font-bold text-sm ${
              index < 3
                ? 'bg-accent-500 text-background-50'
                : 'bg-secondary-100 text-secondary-800'
            }`}
          >
            {index + 1}
          </span>
          <div className="w-11 h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
            <img
              src={item.cover}
              alt={`${item.title} 封面`}
              title={`${item.title} - 91大神影视大全`}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="text-sm font-medium text-foreground-950 truncate">{item.title}</h3>
            <p className="text-xs text-foreground-500 mt-1 truncate">
              {item.type} · {item.year} · {item.region}
            </p>
            <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
              <span className="flex items-center gap-0.5 text-accent-600 font-medium">
                <i className="ri-star-fill" />
                {item.rating.toFixed(1)}
              </span>
              <span className="flex items-center gap-0.5">
                <i className="ri-fire-line text-accent-500" />
                {formatViews(item.views)}
              </span>
            </div>
          </div>
          <i className="ri-arrow-right-s-line text-xl text-foreground-300" />
        </Link>
      ))}
    </div>
  );
}